import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { PalantirBadgeTheme } from './badge.type';

@Component({
  selector: 'palantir-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class PalantirBadgeComponent {
  @Input() public theme: PalantirBadgeTheme = 'primary-solid';
}
